import { useStyles } from "../../style";
import DownloadIcon from "../../../../Assets/images/download-btn-icon.svg";
import HSNSampleSheet from "../../../../Assets/images/hsn-sample-excel-sheet.png";

interface Props {
  downloadStart: boolean;
  handleDownloadFile: () => void;
}

const DownloadAndUpdateSheetModalContent = ({ downloadStart, handleDownloadFile }: Props) => {
  const classes: any = useStyles();
  return (
    <div className="flex flex-column justify-center items-center">
      <p className="mv0 ds-pt60">Download your current catalog & update the HSN/SAC code carefully.</p>
      <button className={classes.downloadGstSheetBtn} onClick={handleDownloadFile}>
        <div className="flex items-center justify-center">
          <img src={DownloadIcon} width="13px" height="13px" />
          <p className="mv0 ds-ml10">{downloadStart ? "Downloading..." : "Download Sheet"}</p>
        </div>
      </button>
      <img src={HSNSampleSheet} width="547px" height="145px" className="ds-mt36" style={{ height: "max-content" }} />
    </div>
  );
};

export default DownloadAndUpdateSheetModalContent;
